
import moment from '@package/moment';

import request from '@package/request';


let interval = null;
const source = [];

const Log = function(owner, level, message, time) {
  this.owner = owner || 'unknown';
  this.level = level || 'info';
  this.message = message || '';
  this.time = time || moment().format();
};

const send = async () => {
  const forSend = source.splice(0);

  if ( ! forSend.length) {
    return;
  }

  try {

    await request({
      url: '/logger',
      method: 'post',
      data: forSend,
    });
  }
  catch(error) {

    source.push(...forSend);
  }
};


export const push = (log) => {
  source.push(new Log(log['owner'], log['level'], log['message']));
};

export const start = () => {
  interval = setInterval(send, 5000);
};

export const stop = () => {
  clearInterval(interval);
};
